module.exports = __webpack_public_path__ + "static/umcpfoundation-ed6681d1ddb1931cf122d16cfe0b4d51.jpg";